import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-create-consent-form',
  templateUrl: './create-consent-form.component.html',
  styleUrls: ['./create-consent-form.component.css']
})
export class CreateConsentFormComponent implements OnInit {
  public consentForm: UntypedFormGroup;
  accountId: any;
  question_details: any;
  qnr_list: any;
  btndisabled = false;
  api_error: any;
  api_success: string;
  type: any;
  settingId: any;
  formDetails: Object;
  title: string;
  constructor(private formbuilder: UntypedFormBuilder,
    private matDialog: MatDialogRef<any>,
    private accountService: AccountService,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit(): void {
    this.accountId = this.data.accountId;
    if (this.accountId) {
      this.getQnr();
    }

    this.createForm();
    this.type = this.data.action;
    this.settingId = this.data.data;
    if (this.type === 'update') {
      this.title = 'Update'
      if (this.accountId) {
        this.getFormDetailsById(this.accountId, this.settingId);
      }
    }else{
      this.title = 'Create'
    }
   
  }
  getFormDetailsById(accountId, settingId) {
    this.accountService.getFormDetailsById(accountId, settingId)
      .subscribe(res => {
        this.formDetails = res;
        this.updateForm(this.formDetails);
      });
  }
  createForm() {
    this.consentForm = this.formbuilder.group({
      name: [],
      description: [],
      qnrIds: [],
    });
  }
  updateForm(formDetails) {
    
    this.consentForm.patchValue({
      name: formDetails.name,
      description: formDetails.description,
      qnrIds: formDetails.qnrIds[0]
    });
    this.adjustTextAreaSize();
  }
  getQnr() {
    this.accountService.getQuestions(this.accountId)
      .subscribe(res => {
        this.question_details = res;
        this.qnr_list = this.question_details.filter(data => data.transactionType === "CONSENT_FORM");
        console.log(this.qnr_list, ' this.qnr_list')
      });
  }
  createConsentForm() {
    this.btndisabled = false;
    const qnrArray = [];
    qnrArray.push(this.consentForm.get('qnrIds').value)
    const postdata = {
      name: this.consentForm.get('name').value,
      description: this.consentForm.get('description').value,
    };
    console.log(this.consentForm.get('qnrIds').value)
    if(this.consentForm.get('qnrIds').value){
      postdata['qnrIds'] = qnrArray;
    }else{
      postdata['qnrIds'] = [];
    }
    if (this.type === 'update') {
      postdata['id'] = this.settingId;
      this.accountService.updateConsentForm(this.accountId, postdata)
        .subscribe(res => {
          this.api_success = 'Consent form Updated successfully';
          setTimeout(() => {
            this.matDialog.close();
          }, 2000);
        },
          (error) => {
            this.api_error = error.error;
            this.btndisabled = false;
          });
    } else {
      this.accountService.createConsentForm(this.accountId, postdata)
        .subscribe(res => {
          this.api_success = 'Consent form Created successfully';
          setTimeout(() => {
            this.matDialog.close();
          }, 2000);
        },
          (error) => {
            this.api_error = error.error;
            this.btndisabled = false;
          });
    }
  }
  adjustTextAreaSize(): void {
    const textArea = document.getElementsByTagName('textarea')[0];
    const words = this.consentForm.get('description').value.split(' ').length;
    const rows = Math.max(Math.ceil(words / 10), 1); // Adjust rows based on words (assuming 10 words per row)
    textArea.rows = rows;
  }
}
